import { ProjectsListController } from './projects.list';

export function ProjectsController() {

  const projectsList = new ProjectsListController();

};


